import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { serviceList, ServiceCard } from '../source/index';
import { MENU } from '../constants/index';

const isEvenNumber = (index: number) => (index + 1) % 2 === 0;

const useStyles = makeStyles(() => ({
  service: {
    padding: '42px 50px',
    background: '#fff',
    '& h1': {
      fontSize: 42,
      textAlign: 'center'
    },
    '@media (max-width: 1260px)': {
      padding: '0 0 60px 0'
    }
  },
}));

const cardUseStyles = makeStyles(() => {
  return {
    card: (index: any) => ({
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      paddingTop: 56,
      flexDirection: isEvenNumber(index) ? 'row-reverse' : 'row',
      '& img': {
        width: '25%'
      },
      '@media (max-width: 1260px)': {
        '& img': {
          width: '50%'
        }
      }
    }),
    cardText: (index: any) => ({
      '@media (max-width: 1260px)': {
        width: '42%',
      },
      width: '35%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      '& h2': {
        fontSize: 28,
        margin: 0,
        textAlign: isEvenNumber(index) ? 'right' : 'left'
      },
      '& div': {
        '& h4': {
          color: '#333',
          fontSize: 18,
          margin: '0 0 24px 0',
          textAlign: isEvenNumber(index) ? 'right' : 'left',
          '& span': {
            marginRight: isEvenNumber(index) ? '0px' : '20px',
            marginLeft: isEvenNumber(index) ? '20px' : '0px',
          },
          '@media (max-width: 1260px)': {
            color: '#666',
            fontSize: 16,
            margin: '0 0 18px 0',
            '& span': {
              marginRight: isEvenNumber(index) ? '0px' : '10px',
              marginLeft: isEvenNumber(index) ? '10px' : '0px',
            },
          }
        },
        '&:last-child': {
          display: 'flex',
          flexDirection: isEvenNumber(index) ? 'row-reverse' : 'row',
        }
      },
      '& button': {
        width: 128,
        height: 40,
        color: '#9595cc',
        background: '#fff',
        border: '1px solid #9595cc',
        cursor: 'pointer',
        '&:hover': {
          background: '#fffafa'
        }
      }
    })
  };
});

const CardComponent: React.FC<{
  data: ServiceCard,
  index: number,
  isShowInHome: boolean,
  setMenu?: React.Dispatch<React.SetStateAction<string>>
}> = ({ data, index, isShowInHome, setMenu }) => {
  const classes = cardUseStyles(index);

  return (
    <div className={classes.card}>
      <div className={classes.cardText}>
        <h2>{data.name}</h2>
        <div>
          <h4>{ data.label1.map((text, idx) => <span key={`label1-${idx}`}>{text}</span>) }</h4>
          <h4>{ data.label2.map((text, idx) => <span key={`label2-${idx}`}>{text}</span>) }</h4>
        </div>
        <div>
          {isShowInHome && <button onClick={() => setMenu?.(MENU.consult)}>{data.button}</button>}
        </div>
      </div>
      <img src={data.img} alt="" />
    </div>
  );
};

const ServiceComponent: React.FC<{ menuKey?: string, setMenu?: React.Dispatch<React.SetStateAction<string>> }> = ({ menuKey, setMenu }) => {
  const classes = useStyles();
  const isShowInHome = useMemo(() => menuKey === MENU.home, [menuKey]);
  const cardData = useMemo(() => isShowInHome ? serviceList.slice(0, 4) : serviceList, [isShowInHome]);

  return (
    <div className={classes.service}>
      { isShowInHome && <h1>我们的服务</h1>}
      { cardData.map((data, index) => <CardComponent key={`card${index}`} data={data} index={index} isShowInHome={isShowInHome} setMenu={setMenu} />) }
    </div>
  );
}

export default ServiceComponent;